import React, { useState, useEffect } from "react";
import "./App.css";
import config from "./config";
import useActivityTracker from "./hooks/Useactivitytracker";

// Homepage Components
import HomepageHeader from "./Homepage/Header";
import Home from "./Homepage/Home";
import About from "./Homepage/About";
import Contact from "./Homepage/Contact";
import HomepageLogin from "./Homepage/Login";

// Admin Components
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import ViewProfile from "./Admin_pages/Profile";
import RequestTypePage from "./Maintenance/RequestTypePage";

// User Components
import UserDashboard from "./User_Pages/Userdashboard";

// Pages
import Dashboard from "./Admin_pages/Dashboard";
import Profile from "./Admin_pages/Profile";
import UserManagement from "./Admin_pages/UserManagement";
import Maintenance from "./Components/Maintenance";
import Settings from "./Admin_pages/Settings";
import AffectedPage from "./Maintenance/AffectedPage";
import CreateTicketFile_modal from "./CreateTicket/CreateTicketFile_modal";
import IssueTypePage from "./Maintenance/IssueTypePage";
import TagsPage from "./Maintenance/TagsPage";
import ComponentsPage from "./Maintenance/ComponentsPage";
import UserAdminManagement from "./Maintenance/UserAdminManagement";
import CategoryPage from "./Maintenance/TicketCategoriesPage";
import SLAPage from "./Maintenance/SLAPage";
import FeedbackPage from "./Maintenance/FeedbackPage";
import OriginsPage from "./Maintenance/OriginsPage";
import CalendarApp from "./Components/CalendarApp";
import WebsiteInfoPage from "./Maintenance/WebsiteInfoPage";
import TicketsPage from "./Components/Ticket/TicketsPage";
import TaskTicket from "./Components/KanbanTicket/TaskTicket";
import TicketComplete from "./Components/KanbanTicket/TicketComplete";
import TicketPending from "./Components/KanbanTicket/TicketPending";
import ViewProfiles from "./Admin_pages/Viewprofile";
import OpenTickets from "./Components/Ticket/OpenTickets";
import ClosedTickets from "./Components/Ticket/ClosedTickets";
import AdminMessenger from "./Admin_Messenger/Admin_Messenger";
import AdminMessengerBubble from "./Admin_Messenger/AdminMessengerBubble";
import AddCustomerList from "./Admin_pages/Addcustomerlist";
import CustomerList from "./Admin_pages/Customerlist";
import Workload from "./Components/Reports";
import Oncall from "./Components/Oncall";
import FlowchartBuilder from "./CreateFlowChart/FlowchartBuilder";
import PermissionManager from "./Maintenance/Permissionmanager";
import ReviewContact from "./Components/Reviewcontact";
import Plugin from "./Components/Plugin";
import Incident from "./Components/Incident";
import Archived from "./Create_plan_Trello/Archived";
import { CardModal } from "./Create_plan_Trello/Shared";
import MyCards from "./Create_plan_Trello/Mycards";
import BoardView from "./Create_plan_Trello/Boardview";
import ListView from "./Create_plan_Trello/Listview";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || null);
  const [currentPage, setCurrentPage] = useState(localStorage.getItem("currentPage") || "home");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);

  const adminUsername = localStorage.getItem("username") || localStorage.getItem("adminUsername") || "admin";

  useActivityTracker();

  useEffect(() => {
    const mobile = window.innerWidth < 768;
    setIsMobile(mobile);
    setIsSidebarOpen(!mobile);

    const handleResize = () => {
      const m = window.innerWidth < 768;
      setIsMobile(m);
      setIsSidebarOpen(!m);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      const adminRaw = localStorage.getItem("admin");
      if (adminRaw) {
        const admin = JSON.parse(adminRaw);
        if (admin?.username && admin.username !== "superadmin") {
          const formData = new URLSearchParams();
          formData.append("username", admin.username);
          await fetch(`${config.API_BASE_URL}/Admin/logout`, {
            method: "POST",
            body: formData,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });
        }
      }
    } catch (err) {
      console.warn("⚠️ Logout API error:", err);
    } finally {
      localStorage.clear();
      setIsLoggedIn(false);
      setUserRole(null);
      setCurrentPage("home");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (isMobile) setIsSidebarOpen(false);
    localStorage.setItem("currentPage", page);
  };

  const homepagePages = ["home", "about", "contact", "login"];
  const [columns, setColumns] = useState([]);
  const [cards, setCards] = useState([]);

  const renderHomepage = () => {
    switch (currentPage) {
      case "home": return <Home setCurrentPage={setCurrentPage} />;
      case "about": return <About />;
      case "contact": return <Contact />;
      case "login": return <HomepageLogin setIsLoggedIn={setIsLoggedIn} setCurrentPage={setCurrentPage} setUserRole={setUserRole} />;
      default: return <Home setCurrentPage={setCurrentPage} />;
    }
  };

  const renderAdminPage = () => {
    switch (currentPage) {
      case "dashboard": return <Dashboard />;
      case "profile": return <Profile />;
      case "users": return <UserManagement />;
      case "maintenance": return <Maintenance handlePageChange={handlePageChange} />;
      case "configuration": return <Settings />;
      case "ViewEditProfile": return <ViewProfile />;
      case "UserAdminManagement": return <UserAdminManagement />;
      case "IssueTypePage": return <IssueTypePage handlePageChange={handlePageChange} />;
      case "TagsPage": return <TagsPage handlePageChange={handlePageChange} />;
      case "ComponentsPage": return <ComponentsPage handlePageChange={handlePageChange} />;
      case "CategoryPage": return <CategoryPage handlePageChange={handlePageChange} />;
      case "SLAPage": return <SLAPage handlePageChange={handlePageChange} />;
      case "OriginsPage": return <OriginsPage handlePageChange={handlePageChange} />;
      case "FeedbackPage": return <FeedbackPage handlePageChange={handlePageChange} />;
      case "CalendarApp": return <CalendarApp handlePageChange={handlePageChange} />;
      case "RequestTypePage": return <RequestTypePage handlePageChange={handlePageChange} />;
      case "WebsiteInfoPage": return <WebsiteInfoPage handlePageChange={handlePageChange} />;
      case "TicketsPage": return <TicketsPage handlePageChange={handlePageChange} />;
      case "TaskTicket": return <TaskTicket handlePageChange={handlePageChange} />;
      case "TicketComplete": return <TicketComplete handlePageChange={handlePageChange} />;
      case "TicketPending": return <TicketPending handlePageChange={handlePageChange} />;
      case "OpenTickets": return <OpenTickets handlePageChange={handlePageChange} />;
      case "ClosedTickets": return <ClosedTickets handlePageChange={handlePageChange} />;

      // ── AdminMessenger: auto-select user from bubble maximize ──
      case "AdminMessenger": return (
        <AdminMessenger
          adminUsername={adminUsername}
          handlePageChange={handlePageChange}
          // Pre-select user conversation (from bubble maximize)
          initialUser={(() => {
            const u = localStorage.getItem("messengerOpenUser");
            if (u) localStorage.removeItem("messengerOpenUser");
            return u || null;
          })()}
          // Pre-select admin DM + switch to admins tab (from bubble admin chat click)
          initialAdminChat={(() => {
            const a = localStorage.getItem("messengerOpenAdminChat");
            if (a) localStorage.removeItem("messengerOpenAdminChat");
            return a || null;
          })()}
          initialTab={(() => {
            const t = localStorage.getItem("messengerOpenTab");
            if (t) localStorage.removeItem("messengerOpenTab");
            return t || "users";
          })()}
        />
      );

      case "ViewProfiles": return <ViewProfiles handlePageChange={handlePageChange} />;
      case "AddCustomerList": return <AddCustomerList handlePageChange={handlePageChange} />;
      case "CustomerList": return <CustomerList handlePageChange={handlePageChange} />;
      case "Workload": return <Workload handlePageChange={handlePageChange} />;
      case "Oncall": return <Oncall handlePageChange={handlePageChange} />;
      case "AffectedPage": return <AffectedPage handlePageChange={handlePageChange} />;
      case "FlowchartBuilder": return <FlowchartBuilder handlePageChange={handlePageChange} />;
      case "Incident": return <Incident handlePageChange={handlePageChange} />;
      case "Plugin": return <Plugin handlePageChange={handlePageChange} />;
      case "ReviewContact": return <ReviewContact handlePageChange={handlePageChange} />;
      case "PermissionManager": return <PermissionManager handlePageChange={handlePageChange} />;
      case "CardModal": return <CardModal handlePageChange={handlePageChange} />;
      case "Archived": return <Archived columns={columns} cards={cards} setCards={setCards} handlePageChange={handlePageChange} />;
      case "MyCards": return <MyCards columns={columns} cards={cards} setCards={setCards} />;
      case "BoardView": return <BoardView columns={columns} cards={cards} setColumns={setColumns} setCards={setCards} onCardClick={() => {}} />;
      case "ListView": return <ListView columns={columns} cards={cards} setCards={setCards} />;
      default: return <Dashboard />;
    }
  };

  if (!isLoggedIn && homepagePages.includes(currentPage)) {
    return (
      <div className="min-h-screen bg-gray-900">
        <HomepageHeader currentPage={currentPage} setCurrentPage={setCurrentPage} />
        {renderHomepage()}
      </div>
    );
  }

  if (!isLoggedIn) {
    setCurrentPage("home");
    return (
      <div className="min-h-screen bg-gray-900">
        <HomepageHeader currentPage="home" setCurrentPage={setCurrentPage} />
        <Home setCurrentPage={setCurrentPage} />
      </div>
    );
  }

  if (isLoggedIn && userRole === "user") {
    return <UserDashboard setIsLoggedIn={setIsLoggedIn} setCurrentPage={setCurrentPage} />;
  }

  // Logged in as ADMIN
  return (
    <div className="flex h-screen bg-gray-900 overflow-hidden">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        isMobile={isMobile}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleLogout={handleLogout}
      />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
        !isMobile && isSidebarOpen ? "ml-64" : !isMobile ? "ml-20" : "ml-0"
      }`}>
        <Header
          isMobile={isMobile}
          setIsSidebarOpen={setIsSidebarOpen}
          onOpenCreate={() => setOpenCreate(true)}
          isSidebarOpen={isSidebarOpen}
          setIsLoggedIn={setIsLoggedIn}
          onLogout={handleLogout}
        />
        <div className="flex-1 overflow-auto ">
          {renderAdminPage()}
        </div>
        {openCreate && <CreateTicketFile_modal onClose={() => setOpenCreate(false)} />}
      </div>

      {/* Floating Messenger Bubble — hidden when already on AdminMessenger page */}
      {currentPage !== "AdminMessenger" && (
        <AdminMessengerBubble
          adminUsername={adminUsername}
          handlePageChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default App;